var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.highlightedOrder
      ? _c("div", { staticClass: "pickup-order-ready-overlay" }, [
          _c("div", { staticClass: "pickup-order-ready-content" }, [
            _vm.highlightedOrder &&
            _vm.highlightedOrder.customer &&
            _vm.highlightedOrder.customer.id > 1 &&
            _vm.highlightedOrder.customer.name &&
            _vm.highlightedOrder.customer.name.toUpperCase() !== "NÃO INFORMADO"
              ? _c("span", { staticClass: "pickup-order-ready-customer" }, [
                  _vm._v(
                    _vm._s(_vm.getFirstName(_vm.highlightedOrder.customer.name))
                  ),
                ])
              : _vm._e(),
            _c("span", { staticClass: "pickup-order-ready-title" }, [
              _vm._v("seu pedido está pronto"),
            ]),
            _c("span", { staticClass: "pickup-order-ready-id" }, [
              _vm._v(_vm._s(_vm.highlightedOrder.id.toString().slice(-3))),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("section", { staticClass: "p-1" }, [
      _c(
        "header",
        {
          staticClass: "pb-1 d-flex justify-content-between align-items-start",
        },
        [
          _c("div", { staticClass: "d-flex column align-items-center" }, [
            _c(
              "span",
              { staticClass: "brand-logo mr-1" },
              [
                _c("b-img", {
                  staticClass: "rounded",
                  attrs: {
                    id: "logo",
                    src: _vm.style ? _vm.style.reducedHeaderImage : "",
                    alt: "logo",
                    fluid: "",
                  },
                }),
              ],
              1
            ),
            _c("h1", { staticClass: "text-dark h1 mb-0" }, [
              _vm._v(" " + _vm._s(_vm.$t("Retirada")) + " "),
            ]),
          ]),
          _vm.filter.storeId
            ? _c(
                "div",
                [
                  _c("b-avatar", {
                    staticClass: "badge-minimal ml-1",
                    attrs: {
                      size: "40",
                      icon: "wifi",
                      variant: "light-primary",
                      badge: "",
                      "badge-variant": _vm.preparationWebSocketConnected
                        ? "success"
                        : "danger",
                      title: _vm.$t(
                        "Indica o status da conexão com a atualização dos pedidos de preparação"
                      ),
                    },
                  }),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "link-primary",
                        title: _vm.$t("Atualizar lista de pedidos"),
                      },
                      on: { click: _vm.getData },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "arrow-clockwise", "font-scale": "1" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "link-primary",
                        title: _vm.$t("Testar som"),
                      },
                      on: { click: _vm.testSound },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "volume-up", "font-scale": "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { "min-width": "300px" } },
            [
              !_vm.filter.storeId
                ? [
                    _c("e-store-combo", {
                      attrs: {
                        disabled: !_vm.ready,
                        required: false,
                        "show-label": false,
                        clearable: true,
                        placeholder: _vm.ready
                          ? _vm.$t("Selecione")
                          : _vm.$t("Aguarde..."),
                      },
                      on: { input: _vm.getData },
                      model: {
                        value: _vm.filter.storeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "storeId", $$v)
                        },
                        expression: "filter.storeId",
                      },
                    }),
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass: "store-label",
                        staticStyle: {
                          cursor: "pointer",
                          "min-height": "38px",
                          display: "flex",
                          "align-items": "center",
                          padding: "0 12px",
                          background: "#f8f9fa",
                          "font-size": "1.5rem",
                        },
                        attrs: { title: _vm.$t("Clique para alterar a loja") },
                        on: {
                          click: function ($event) {
                            _vm.filter.storeId = null
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.store.tradingName) + " ")]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
      !_vm.filter.storeId
        ? _c("div", { staticClass: "text-center" }, [
            _c("span", { staticClass: "h2" }, [
              _vm._v(" " + _vm._s(_vm.needSearchMessage)),
            ]),
          ])
        : _c("div", [
            _c("div", { staticClass: "kanban-board d-flex" }, [
              _c(
                "div",
                { staticClass: "kanban-column flex-fill mr-25" },
                [
                  _c(
                    "h1",
                    { staticClass: "text-center kanban-title kanban-pending" },
                    [_vm._v(" Aguardando ")]
                  ),
                  _vm._l(_vm.aguardandoOrders, function (order) {
                    return _c(
                      "div",
                      { key: order.id, staticClass: "pickup-order" },
                      [
                        _c("span", { staticClass: "pickup-order-id" }, [
                          _vm._v(_vm._s(order.id.toString().slice(-3))),
                        ]),
                        order.customer.id > 1 &&
                        order.customer.name &&
                        order.customer.name.toUpperCase() !== "NÃO INFORMADO"
                          ? _c("span", { staticClass: "pickup-customer" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getFirstName(order.customer.name))
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "kanban-column flex-fill mr-25" },
                [
                  _c(
                    "h1",
                    {
                      staticClass: "text-center kanban-title kanban-preparing",
                    },
                    [_vm._v(" Preparando ")]
                  ),
                  _vm._l(_vm.preparandoOrders, function (order) {
                    return _c(
                      "div",
                      { key: order.id, staticClass: "pickup-order" },
                      [
                        _c("span", { staticClass: "pickup-order-id" }, [
                          _vm._v(_vm._s(order.id.toString().slice(-3))),
                        ]),
                        order.customer.id > 1 &&
                        order.customer.name &&
                        order.customer.name.toUpperCase() !== "NÃO INFORMADO"
                          ? _c("span", { staticClass: "pickup-customer" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getFirstName(order.customer.name))
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "kanban-column flex-fill" },
                [
                  _c(
                    "h1",
                    {
                      staticClass: "text-center kanban-title kanban-completed",
                    },
                    [_vm._v(" Pronto ")]
                  ),
                  _vm._l(_vm.prontoOrders, function (order) {
                    return _c(
                      "div",
                      { key: order.id, staticClass: "pickup-order" },
                      [
                        _c("span", { staticClass: "pickup-order-id" }, [
                          _vm._v(_vm._s(order.id.toString().slice(-3))),
                        ]),
                        order.customer.id > 1 &&
                        order.customer.name &&
                        order.customer.name.toUpperCase() !== "NÃO INFORMADO"
                          ? _c("span", { staticClass: "pickup-customer" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getFirstName(order.customer.name))
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }